function mostrarResultadoConsulta(order) {
  const resultadoDiv = document.getElementById('resultado-consulta');

  const estadoOriginalSinProcesar = order.estado;

  const estaPagada = order.estado === "PXR PAGADO" ||
    order.estado === "Pagado" ||
    order.estado === "" ||  // *** AGREGAR ESTA LÍNEA ***
    (order.estado && order.estado.includes("PXR PAGADO")) ||
    (order['Estado Pago'] && order['Estado Pago'].toLowerCase().includes('pagado'));


  if (order.estado === "" || order.estado === null || order.estado === undefined) order.estado = "Solicitud Recibida";

  const codigoBeca = order['Código BECA'] || order['C\u00f3digo BECA'] || '';

  const ordenIdOriginal = sessionStorage.getItem('ordenIdOriginal') ||
    document.getElementById('consulta-reparacion')?.value?.trim() ||
    codigoBeca.replace(/[^\d]/g, '') ||
    codigoBeca;

  let resultado = `<h5>Estado de la Orden de Reparación</h5><div class="resultado-contenido">`;

  const camposMostrar = [
    { clave: 'estado', etiqueta: 'Estado de la orden', clase: true },
    { clave: 'Fecha de Ingreso al SSTT', etiqueta: 'Fecha de Ingreso', formatear: true },
    { clave: 'Garantía', etiqueta: 'Garantía', clase: true },
    { clave: 'RUT', etiqueta: 'Cliente' },
    { clave: 'Familia del Producto', etiqueta: 'Categoría del producto' },
    { clave: 'Nombre del Producto', etiqueta: 'Producto' },
    { clave: 'Modelo del Producto', etiqueta: 'Modelo' },
    { clave: 'Marca del Producto', etiqueta: 'Marca' },
    { clave: 'N\u00famero de Serie del Producto', etiqueta: 'Número de serie' },
    { clave: 'Número de Serie del Producto', etiqueta: 'Número de serie' },
    { clave: 'Sucursal', etiqueta: 'Adquirido en' },
    { clave: 'Fecha de Compra', etiqueta: 'Fecha de compra' },
    { clave: 'N\u00famero de Boleta', etiqueta: 'Número de boleta' },
    { clave: 'Número de Boleta', etiqueta: 'Número de boleta' },
    { clave: 'Sintoma del Producto', etiqueta: 'Síntomas reportados', parrafo: true },
    { clave: 'Direcci\u00f3n', etiqueta: 'Dirección' },
    { clave: 'Dirección', etiqueta: 'Dirección' },
    { clave: 'Ciudad', etiqueta: 'Ciudad/Comuna' },
    { clave: 'Regi\u00f3n', etiqueta: 'Región' },
    { clave: 'Región', etiqueta: 'Región' },
    { clave: 'Modo de Entrega', etiqueta: 'Entrega' },
    { clave: 'Valor Despacho', etiqueta: 'Valor Despacho', formatearMoneda: true },
    { clave: 'Valor Reparaci\u00f3n', etiqueta: 'Valor Reparación', formatearMoneda: true },
    { clave: 'Valor Reparación', etiqueta: 'Valor Reparación', formatearMoneda: true },
    { clave: 'Estado Pago', etiqueta: 'Estado de Pago', clase: true }
  ];

  const camposMostrados = new Set();
  let valorReparacion = 0, valorDespacho = 0;

  for (const campo of camposMostrar) {
    if (order[campo.clave] && !camposMostrados.has(campo.etiqueta)) {
      let valor = decodeHTMLEntities(order[campo.clave]);

      if (campo.formatear) valor = formatearFecha(valor);

      if (campo.formatearMoneda) {
        const valorNumerico = parseFloat(valor.toString().replace(/[^\d.-]/g, ''));
        if (!isNaN(valorNumerico)) {
          if (campo.etiqueta === 'Valor Reparación') valorReparacion = valorNumerico;
          else if (campo.etiqueta === 'Valor Despacho') valorDespacho = valorNumerico;
        }
        valor = isNaN(valorNumerico) ? valor : `$${valorNumerico.toLocaleString('es-CL')}`;
      }

      const claseAdicional = campo.clase ? `class="${getEstadoClase(valor)}"` : '';
      const contenido = campo.parrafo ? `<p>${valor}</p>` : `<span ${claseAdicional}>${valor}</span>`;

      resultado += `<div class="resultado-item"><strong>${campo.etiqueta}:</strong>${contenido}</div>`;
      camposMostrados.add(campo.etiqueta);
    }
  }

  const procesarCampoValor = (clave, etiqueta, valorVariable) => {
    if (!camposMostrados.has(etiqueta) && order[clave]) {
      const valorCampo = order[clave];
      const valorNumerico = parseFloat(valorCampo.toString().replace(/[^\d.-]/g, ''));
      if (!isNaN(valorNumerico)) {
        if (etiqueta === 'Valor Reparación') valorReparacion = valorNumerico;
        else if (etiqueta === 'Valor Despacho') valorDespacho = valorNumerico;
      }
      const valorFormateado = isNaN(valorNumerico) ? valorCampo : `$${valorNumerico.toLocaleString('es-CL')}`;
      resultado += `<div class="resultado-item"><strong>${etiqueta}:</strong><span>${valorFormateado}</span></div>`;
      camposMostrados.add(etiqueta);
      return true;
    }
    return false;
  };

  procesarCampoValor("Valor Reparación", "Valor Reparación", valorReparacion);
  procesarCampoValor("Valor Despacho", "Valor Despacho", valorDespacho);

  if (!camposMostrados.has('Valor Reparación')) {
    const claveReparacion = Object.keys(order).find(k =>
      k.includes('Valor') && (k.includes('Reparaci') || k.includes('Reparación') || k.includes('reparaci') || k.includes('reparación')));
    if (claveReparacion && order[claveReparacion]) {
      procesarCampoValor(claveReparacion, "Valor Reparación", valorReparacion);
    }
  }

  if (!camposMostrados.has('Valor Despacho')) {
    const claveDespacho = Object.keys(order).find(k => k.includes('Valor') && (k.includes('Despacho') || k.includes('despacho')));
    if (claveDespacho && order[claveDespacho]) {
      procesarCampoValor(claveDespacho, "Valor Despacho", valorDespacho);
    }
  }

  const valorTotal = valorReparacion + valorDespacho;
  
  // Guardar datos del cliente en sessionStorage para usarlos en el pago
  const rut = order['RUT'] || '';
  const nombre = order['Nombre'] || order['Nombre Cliente'] || order['Cliente'] || order['Nombre del Cliente'] || '';
  // Buscar dirección con diferentes encodings posibles
  const direccion = order['Dirección'] || order['Direcci\u00f3n'] || order['Direcci n'] || '';
  const ciudad = order['Ciudad'] || '';
  // Buscar región con diferentes encodings posibles
  const region = order['Región'] || order['Regi\u00f3n'] || order['Regi n'] || '';
  
  console.log('=== DATOS DE INES V4 ===');
  console.log('RUT:', rut);
  console.log('Nombre:', nombre);
  console.log('Dirección:', direccion);
  console.log('Ciudad:', ciudad);
  console.log('Región:', region);
  console.log('=== TODOS LOS CAMPOS DE INES ===');
  console.log(JSON.stringify(order, null, 2));
  
  if (rut) sessionStorage.setItem('ordenRut', rut);
  if (nombre) sessionStorage.setItem('ordenNombre', nombre);
  if (direccion) sessionStorage.setItem('ordenDireccion', direccion);
  if (ciudad) sessionStorage.setItem('ordenCiudad', ciudad);
  if (region) sessionStorage.setItem('ordenRegion', region);
  
  console.log('SessionStorage guardado:');
  console.log('- ordenDireccion:', sessionStorage.getItem('ordenDireccion'));
  console.log('- ordenCiudad:', sessionStorage.getItem('ordenCiudad'));
  console.log('- ordenRegion:', sessionStorage.getItem('ordenRegion'));

  if (valorTotal > 0 && !estaPagada) {
    resultado += `
     <div class="email-pago-container">
       <label for="nombre-pago" style="color: #666; font-weight: bold;">Nombre completo:</label>
       <input type="text" id="nombre-pago" value="" placeholder="Ingrese su nombre completo" style="margin-bottom: 10px;">
       <label for="email-pago" style="color: #666; font-weight: bold;">Correo electrónico para el pago:</label>
       <input type="email" id="email-pago" value="" placeholder="Ingrese su correo electrónico">
     </div>
     <div style="display:flex; align-items:center; justify-content:space-between; margin:15px 0; padding:15px; border:1px solid #d0d0d0; border-radius:6px; background-color:#f5f8ff;">
       <div style="display:flex; align-items:center;">
         <strong>Valor a pagar:</strong>
         <span style="font-weight:700; color:#bd2d34; margin-left:10px;">$${valorTotal.toLocaleString('es-CL')}</span>
       </div>
       <div id="contenedor-boton-pago">
         <button type="button" class="btn-pagar" onclick="iniciarPagoFlow('${ordenIdOriginal}', ${valorTotal}, document.getElementById('email-pago').value, document.getElementById('nombre-pago').value)">Pagar con Flow</button>
       </div>
     </div>
   `;
  } else if (valorTotal > 0 && estaPagada) {
    resultado += `
     <div style="margin:15px 0; padding:15px; border:1px solid #66bb6a; border-radius:6px; background-color:#e8f5e9; display:flex; align-items:center;">
       <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2e7d32" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="margin-right:15px;">
         <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
         <polyline points="22 4 12 14.01 9 11.01"></polyline>
       </svg>
       <div>
         <strong style="color:#2e7d32; font-size:16px;">Pago realizado correctamente</strong>
         <p style="margin:5px 0 0; color:#2e7d32;">Valor pagado: $${valorTotal.toLocaleString('es-CL')}</p>
       </div>
     </div>
   `;
  }

  if (order.productImage || order.imagen_producto)
    resultado += `<div class="resultado-item"><strong>Imagen del producto:</strong><div class="imagen-contenedor producto-imagen-container fade-in"><img src="${order.productImage || order.imagen_producto}" alt="Imagen del producto" style="max-height:150px;"></div></div>`;

  if (order.boletaImage || order.imagen_boleta)
    resultado += `<div class="resultado-item"><strong>Imagen de la boleta:</strong><div class="imagen-contenedor fade-in"><img src="${order.boletaImage || order.imagen_boleta}" alt="Imagen de la boleta" style="max-height:150px;"></div></div>`;

  resultado += `
   <div class="consulta-botones">
     <button type="button" class="btn-secundario" onclick="resetearFormularios()">Volver</button>
     <button type="button" class="btn-enviar" onclick="document.getElementById('btn-ingresar').click()">Ingresar Nueva Orden</button>
   </div>
 </div>`;

  resultadoDiv.innerHTML = resultado;
}

function obtenerClienteEmail() {
  // Primero intentar obtener del campo de pago si existe
  const emailPagoCampo = document.getElementById('email-pago');
  if (emailPagoCampo && emailPagoCampo.value.trim()) {
    return emailPagoCampo.value.trim();
  }
  // Si no, del formulario de ingreso
  const emailCampo = document.getElementById('cliente-email');
  return emailCampo ? emailCampo.value : null;
}

// ============================================================================
//  Backend nuevo (api.serviciosthorben.cl). Reemplaza a app.alcachofa.cl.
//  - El pago se inicia enviando SOLO ot + nombre + correo; el monto lo calcula
//    el servidor consultando INES (el navegador ya no manda el monto).
//  - Al volver de Flow, el servidor ya actualizó INES, creó la orden en Shopify
//    y envió el comprobante. Aquí solo mostramos el resultado.
// ============================================================================

var API_BASE = 'https://api.serviciosthorben.cl';

function iniciarPagoFlow(ordenId, monto, email, nombre) {
  var nombreInput = document.getElementById('nombre-pago');
  var emailInput = document.getElementById('email-pago');
  var nombreValue = nombreInput ? nombreInput.value.trim() : (nombre || '').trim();
  var emailValue = emailInput ? emailInput.value.trim() : (email || '').trim();

  // Validaciones (mismas que antes)
  if (!nombreValue || nombreValue.split(/\s+/).length < 2) {
    alert('Por favor ingrese su nombre y apellido completo (ejemplo: Juan Pérez).');
    if (nombreInput) {
      nombreInput.focus();
      nombreInput.classList.add('campo-error');
      nombreInput.addEventListener('input', function () { this.classList.remove('campo-error'); }, { once: true });
    }
    return;
  }
  if (!emailValue || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailValue)) {
    alert('Por favor ingrese un correo electrónico válido para continuar con el pago.');
    if (emailInput) {
      emailInput.focus();
      emailInput.classList.add('campo-error');
      emailInput.addEventListener('input', function () { this.classList.remove('campo-error'); }, { once: true });
    }
    return;
  }

  var botonPagar = document.querySelector('.btn-pagar');
  var contenedorBotonPago = document.getElementById('contenedor-boton-pago');
  if (botonPagar) { botonPagar.disabled = true; botonPagar.style.display = 'none'; }

  var spinnerContainer = document.createElement('div');
  spinnerContainer.className = 'cargando-pago-container';
  spinnerContainer.innerHTML = '<div class="cargando-pago-spinner"></div><span class="cargando-pago-text">Conectando con el portal de pagos...</span>';
  if (contenedorBotonPago) contenedorBotonPago.appendChild(spinnerContainer);
  var textElement = spinnerContainer.querySelector('.cargando-pago-text');

  // Se envía SOLO ot + nombre + correo. El monto lo determina el servidor.
  fetch(API_BASE + '/api/iniciar-pago.php', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ ot: ordenId, nombre: nombreValue, email: emailValue })
  })
    .then(function (response) {
      return response.json().then(function (data) { return { ok: response.ok, data: data }; });
    })
    .then(function (res) {
      if (res.ok && res.data && res.data.ok && res.data.url) {
        if (textElement) textElement.textContent = 'Redirigiendo al portal de pagos...';
        setTimeout(function () { window.location.href = res.data.url; }, 600);
      } else {
        var msg = (res.data && res.data.error) ? res.data.error : 'No pudimos iniciar el pago.';
        mostrarError(msg, ordenId);
      }
    })
    .catch(function () {
      mostrarError('No pudimos conectar con el servidor de pagos. Intenta nuevamente en unos minutos.', ordenId);
    });
}

function mostrarError(mensaje, ordenId) {
  var contenedorBotonPago = document.getElementById('contenedor-boton-pago');
  var spinnerContainer = contenedorBotonPago ? contenedorBotonPago.querySelector('.cargando-pago-container') : null;
  if (spinnerContainer) spinnerContainer.remove();

  var botonPagar = document.querySelector('.btn-pagar');
  if (botonPagar) { botonPagar.disabled = false; botonPagar.style.display = 'inline-flex'; }

  var errorDiv = document.createElement('div');
  errorDiv.className = 'error-pago';
  errorDiv.innerHTML = '<p class="error-mensaje"><strong>Error:</strong> ' + mensaje + '</p><button type="button" class="btn-reintentar">Reintentar</button>';
  if (contenedorBotonPago && contenedorBotonPago.parentNode) contenedorBotonPago.parentNode.appendChild(errorDiv);
  else document.getElementById('resultado-consulta').appendChild(errorDiv);

  var btnReintentar = errorDiv.querySelector('.btn-reintentar');
  if (btnReintentar) btnReintentar.addEventListener('click', function () {
    errorDiv.remove();
    if (botonPagar) { botonPagar.disabled = false; botonPagar.style.display = 'inline-flex'; }
  });
}

// ---- Retorno desde Flow: el servidor ya hizo todo; aquí solo se informa ----
function bloqueMensaje(tipo, titulo, texto) {
  var c = { exito:  ['#e8f5e9', '#66bb6a', '#2e7d32'],
            espera: ['#fff8e1', '#ffb300', '#e65100'],
            error:  ['#ffebee', '#f44336', '#d32f2f'] }[tipo] || ['#ffebee', '#f44336', '#d32f2f'];
  return '<div style="background-color:' + c[0] + ';border:1px solid ' + c[1] + ';border-radius:8px;padding:20px;margin:20px 0;text-align:center;">' +
         '<h3 style="color:' + c[2] + ';margin-top:0;">' + titulo + '</h3>' +
         '<p style="margin:5px 0 0;color:' + c[2] + ';">' + texto + '</p></div>';
}

function limpiarUrlPago() {
  if (window.history && window.history.replaceState) {
    window.history.replaceState({}, document.title, window.location.pathname);
  }
}

function esperarConfirmacionPago(orden, caja, intento) {
  if (intento >= 10) {
    caja.innerHTML = bloqueMensaje('espera', 'Pago en verificación',
      'Tu pago sigue en proceso de confirmación. Te avisaremos por correo apenas se complete.');
    limpiarUrlPago();
    return;
  }
  setTimeout(function () {
    fetch(API_BASE + '/api/estado-pago.php?orden=' + encodeURIComponent(orden))
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var estado = data && data.estado ? data.estado : 'pendiente';
        if (estado === 'pagado') {
          caja.innerHTML = bloqueMensaje('exito', '¡Pago realizado con éxito!',
            'Tu orden fue procesada correctamente. Te enviamos el comprobante a tu correo.');
          limpiarUrlPago();
        } else if (estado === 'pendiente') {
          esperarConfirmacionPago(orden, caja, intento + 1);
        } else {
          caja.innerHTML = bloqueMensaje('error', 'Pago no completado',
            (data && data.mensaje) ? data.mensaje : 'El pago no pudo completarse.');
          limpiarUrlPago();
        }
      })
      .catch(function () { esperarConfirmacionPago(orden, caja, intento + 1); });
  }, 3000);
}

document.addEventListener('DOMContentLoaded', function () {
  var params = new URLSearchParams(window.location.search);
  var pago = params.get('pago');
  var orden = params.get('orden');
  if (!pago || !orden) return;

  var contenedor = document.querySelector('.page-width') || document.body;
  var caja = document.createElement('div');
  caja.className = 'pago-resultado-mensaje';
  contenedor.insertBefore(caja, contenedor.firstChild);

  if (pago === 'pagado') {
    caja.innerHTML = bloqueMensaje('exito', '¡Pago realizado con éxito!',
      'Tu orden fue procesada correctamente. Te enviamos el comprobante a tu correo.');
    limpiarUrlPago();
  } else if (pago === 'pendiente') {
    caja.innerHTML = bloqueMensaje('espera', 'Confirmando tu pago',
      'Estamos verificando la transacción. Esto puede tardar unos segundos...');
    esperarConfirmacionPago(orden, caja, 0);
  } else {
    var textos = {
      rechazado: 'El pago fue rechazado. Puedes intentarlo nuevamente.',
      anulado: 'El pago fue anulado. Puedes intentarlo nuevamente.',
      discrepancia: 'Detectamos una diferencia en el monto. Por favor contáctanos para regularizar tu pago.',
      error: 'No pudimos procesar el pago. Si el cobro se realizó, contáctanos.'
    };
    caja.innerHTML = bloqueMensaje('error', 'Pago no completado', textos[pago] || textos.error);
    limpiarUrlPago();
  }
  caja.scrollIntoView({ behavior: 'smooth', block: 'center' });
});